export const CREATE_FULFILMENT_LOCATION = "CREATE_FULFILMENT_LOCATION";
export const GET_Fulfilment_LOCATION = "GET_Fulfilment_LOCATION";
export const SET_Fulfilment_LOCATIONS = "SET_Fulfilment_LOCATIONS";
export const UPDATE_FULFILMENT_LOCATION = "UPDATE_FULFILMENT_LOCATION";